<template>
  <div class="booking-unavailable">
    <div class="unavailable-tour-container">
      <div class="unavailable-tour-icon">
        <img
          :data-src="icon"
          alt="unavailable-tour-icon"
          class="lazyload unavailable-tour-icon-img"
        >
      </div>
      <div class="unavailable-tour-text">
        {{ text }}
      </div>
    </div>

    <BookingSimilarTours
      :tours="tours"
      :title="'Similar Experiences for You:'"
    />
  </div>
</template>
<script>
import BookingSimilarTours from '@/components/containers/tour/BookingSimilarTours.vue';

export default {
  name: 'BookingUnavailable',
  components: {
    BookingSimilarTours
  },
  props: {
    tours: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      icon: require('@/assets/svg/unavailable.svg'),
      text: 'Sorry but tickets for this tour are currently unavailable. Explore similar experiences or check back later for availability!​'
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.booking-unavailable {

}

.unavailable-tour-container {
  display: flex;
  background-color: #BE181F;
  padding: 8px;
  gap: 8px;
  border-radius: 8px;

  margin-bottom: 15px;
}

.unavailable-tour-text {
  @include font__paragraph-2--regular;
  color: #fff;
}

.unavailable-tour-icon {
  flex-shrink: 0;
}
.unavailable-tour-icon-img {
  width: 32px;
  height: 32px;
}
</style>
